import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";
import { assertNoDemoReportMutations } from "./demoReportMutationGuard";

export interface DeleteRecordsInputDto {
  recordIds: string[];
}

/**
 * Use case: удаление записей (оптимистичные апдейты выполняются на уровне store).
 */
export class DeleteRecordsUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(input: DeleteRecordsInputDto): Promise<void> {
    const { recordIds } = input;
    if (!recordIds.length) {
      return;
    }

    const request = {
      change_names: [],
      for_archive: [],
      for_delete: recordIds,
      delete_link: [],
    };
    assertNoDemoReportMutations(request);
    await this.gateway.updateRecords(request);
  }
}
